// shared/pdf/registry.js

import { PDF_THEMES, DEFAULT_THEME } from './themes';

const COMMON_HEADER_FOOTER = [
  { id: 'header', label: 'Derasar Header',   default: true },
  { id: 'footer', label: 'Footer & Page No', default: true },
];

const PDF_REGISTRY = {
  // ── Transactions ────────────────────────────────────────────────────────────
  receipt: {
    label: 'Donation Receipt',
    tab: 'transactions',
    preview: false,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'signature', label: 'Signature Block', default: true },
    ],
  },
  paymentVoucher: {
    label: 'Payment Voucher',
    tab: 'transactions',
    preview: false,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'signature', label: 'Signature Block', default: true },
    ],
  },
  offeringAging: {
    label: 'Offering Aging',
    tab: 'transactions',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },

  // ── Accounting Reports ───────────────────────────────────────────────────────
  balanceSheet: {
    label: 'Balance Sheet',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  incomeExpense: {
    label: 'Income & Expenditure',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'filterLine', label: 'Filter Description', default: true },
    ],
  },
  trialBalance: {
    label: 'Trial Balance',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  categoryFund: {
    label: 'Category Fund',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'filterLine', label: 'Filter Description', default: true },
    ],
  },
  dayBook: {
    label: 'Day Book',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  cashBook: {
    label: 'Cash Book',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  bankBook: {
    label: 'Bank Book',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  goldRegister: {
    label: 'Gold Register',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  itemRegister: {
    label: 'Item Register',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  ledger: {
    label: 'Account Ledger',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'filterLine', label: 'Filter Description', default: true },
    ],
  },
  ledgerBalance: {
    label: 'Ledger Balance',
    tab: 'accounting',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'filterLine', label: 'Filter Description', default: true },
    ],
  },

  // ── Member Reports ───────────────────────────────────────────────────────────
  offerings: {
    label: 'Offerings',
    tab: 'memberReports',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  memberContributions: {
    label: 'Member Contributions',
    tab: 'memberReports',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  pendingBalance: {
    label: 'Pending Balance',
    tab: 'memberReports',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  memberLedger: {
    label: 'Member Ledger',
    tab: 'memberReports',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards', default: true },
    ],
  },
  ownerLedger: {
    label: 'Owner Ledger',
    tab: 'memberReports',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards', default: true },
    ],
  },
  familyReport: {
    label: 'Family Report',
    tab: 'memberReports',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
    ],
  },
  receiptsBook: {
    label: 'Receipts Book',
    tab: 'memberReports',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards', default: true },
    ],
  },
  anonymousDonations: {
    label: 'Shah A/C Donations',
    tab: 'memberReports',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards', default: true },
    ],
  },
  addressBook: {
    label: 'Address Book',
    tab: 'members',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards',      default: true },
      { id: 'filterLine',   label: 'Filter Description', default: true },
    ],
  },
  memberDirectory: {
    label: 'Member Directory',
    tab: 'members',
    preview: true,
    defaultOrientation: 'portrait',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards', default: true },
    ],
  },
  derasarMemberList: {
    label: 'Derasar Members List',
    tab: 'members',
    preview: true,
    defaultOrientation: 'landscape',
    sections: [
      ...COMMON_HEADER_FOOTER,
      { id: 'summaryCards', label: 'Summary Cards', default: true },
    ],
  },
};

/**
 * Merges a saved per-type config row (from user_pdf_configs table) with registry defaults.
 * savedConfig: { theme, orientation, sections } or null
 * Returns { theme, orientation, sections } — fully resolved, no nulls.
 */
const resolvePdfPreferences = (savedConfig, type) => {
  const config = PDF_REGISTRY[type];
  if (!config) throw new Error(`Unknown PDF type: ${type}`);

  const theme       = (savedConfig?.theme && PDF_THEMES[savedConfig.theme]) ? savedConfig.theme : DEFAULT_THEME;
  const orientation = savedConfig?.orientation || config.defaultOrientation;
  const saved       = savedConfig?.sections || {};

  const sections = {};
  config.sections.forEach(({ id, default: def }) => {
    sections[id] = saved[id] !== undefined ? saved[id] : def;
  });

  return { theme, orientation, sections };
};

export { PDF_REGISTRY, resolvePdfPreferences };
